import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36f4263d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { "aria-live": "assertive" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "2.ファイルをアップロード", -1))
const _hoisted_4 = { class: "area-file" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ここにファイルをドラッグ&ドロップ ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" zip形式のファイルを選択してください。 ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "explan-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, "お送りいただく前に資料のファイル、テンプレートに記載したメタデータの内容に間違いないかご確認ください。"),
  /*#__PURE__*/_createElementVNode("li", null, "資料のファイルと、メタデータを記載したテンプレートをzip形式で圧縮してお送りください。")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_InputImageFile = _resolveComponent("InputImageFile")!
  const _component_TextAlert = _resolveComponent("TextAlert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
        return (_openBlock(), _createBlock(_component_Message, {
          key: message.id,
          id: message.id,
          type: message.type,
          text: message.text,
          isDisplay: _ctx.isDisplay,
          onRemove: _ctx.removeMessage
        }, null, 8, ["id", "type", "text", "isDisplay", "onRemove"]))
      }), 128))
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_InputImageFile, {
        onInputImage: _ctx.fileUpload,
        isThumbnailDisplay: false,
        accept: ['application/x-zip-compressed'],
        isShadow: false,
        class: "the-image-search-on-top-page-main"
      }, {
        description: _withCtx(() => [
          (_ctx.file)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.file[0].name), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_6, "ファイルが選択されていません"))
        ]),
        placeholder: _withCtx(() => [
          _createVNode(_component_DssIcon, { icon: "file" }),
          _hoisted_7
        ]),
        _: 1
      }, 8, ["onInputImage"])
    ]),
    (_ctx.props.errMsgFlg)
      ? (_openBlock(), _createBlock(_component_TextAlert, {
          key: 0,
          class: _normalizeClass('errMsg-file')
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_9
  ]))
}